/** * create 2023-06-05 * author siwenqiang */
<template>
  <div class="select-project">
    <h2 class="title">精选项目</h2>
    <div class="tab-box">
      <el-tabs tab-position="left" v-model="activeName">
        <el-tab-pane
          v-for="(item, index) in selectProjectData"
          :key="index"
          :label="item.title"
          :name="String(index)"
        >
          <div class="item-content">
            <ul>
              <li
                v-for="(item1, index) in item.desc.split('▪').slice(1)"
                :key="index"
              >
                <span>▪</span>{{ item1 }}
              </li>
              <el-button type="primary" @click="handleLink(item.url)"
                >体验项目</el-button
              >
            </ul>

            <img :src="item.image && item.image[0] && item.image[0].url" />
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="用户管理" name="first">
          <div class="item-content">
            <div class="item">
              <ul>
                <li>▪ 传智健康管理系统是一款应用于健康管理机构的业务系统</li>

                <li>▪ 传智健康管理系统是一款应用于健康管理机构的业务系统</li>
                <li>▪ 传智健康管理系统是一款应用于健康管理机构的业务系统</li>
              </ul>
              <el-button type="primary">体验项目</el-button>
            </div>
            
          </div>
        </el-tab-pane>
        <el-tab-pane label="配置管理" name="second">项目实战全记录</el-tab-pane>
        <el-tab-pane label="角色管理" name="third">项目实战答辩</el-tab-pane> -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import marked from 'marked';
export default {
  name: 'actualCombat',
  props: {
    selectProjectData: [],
  },
  data() {
    return {
      activeName: 0,
    };
  },
  methods: {
    handleLink(url) {
      let routerData;
      if (url) {
        routerData = this.$router.resolve({
          path: url,
        });
      }
      window.open(routerData.href, '_blank');
    },
    getMarkedData(value) {
      return marked(value || '', {
        sanitize: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.select-project {
  padding: 0 12%;
  margin-top: 70px;
  padding-bottom: 110px;
  .title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #19232b;
    margin-bottom: 35px;
  }
  .tab-box {
    .el-tabs {
      margin: 0px;
      :deep(.el-tabs__nav-wrap::after) {
        background-color: #e4e7ed !important ;
      }
      :deep(.el-tabs__item.is-active) {
        color: #409eff !important;
        background: none !important;
      }
      :deep(.el-tabs__item) {
        background-color: transparent;
        height: 40px !important;
        line-height: 40px !important;
        margin-right: 0px;
        padding: 0 28px;
        font-size: 16px;
        font-family: PingFangSC-Medium;
      }
      :deep(.el-tabs__item:hover) {
        color: #409eff !important;
        cursor: pointer;
      }
      :deep(.el-tabs__active-bar) {
        display: block;
      }
      :deep(.el-tabs__nav-scroll) {
        display: flex;
        justify-content: center;
      }
      :deep(.el-tabs__header) {
        margin-top: 0 !important;
        height: 240px;
      }
    }
    .item-content {
      display: flex;
      height: 240px;
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      .item {
        padding-left: 50px;
        position: relative;
      }
      .el-button {
        position: absolute;
        bottom: 0;
        background-color: #006bff;
        border-color: #006bff;
      }
      img {
        width: 340px;
        height: 191px;
        border-radius: 8px;
      }
      .context {
        padding-left: 80px;
        padding-right: 150px;
        font-size: 15px;
        line-height: 32px;
      }
      ul {
        line-height: 32px;
        font-size: 15px;
        padding-left: 80px;
        padding-right: 100px;
      }
    }
  }
}
</style>
